export class VehicleModel {
  id: number;
  makeId: number;
  name: string;
  active: boolean;

  constructor() {
    this.id = null;
    this.makeId = null;
    this.name = null;
    this.active = null;
  }
}
